import { setLocalStorageWithPrefix } from '../../hooks/useLocalStorage';

export const handleYes = async (openAccountCheck, setEnableModal, setPrequaledFromBanner) => {
  setEnableModal(true);
  setPrequaledFromBanner(true);
  // redirect to webchat
  openAccountCheck.disable();
  setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', true);
};

export const handleNo = async openAccountCheck => {
  openAccountCheck.disable();
  setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', false);
};
